<script setup lang="ts">
  import { computed } from "vue";
  import { Funnel } from "lucide-vue-next";
  import { getConditionsSegments } from "@utils/composables/conditionsOverview";

  const props = withDefaults(
    defineProps<{
      conditions: unknown;
      hasGroups?: boolean;
      prefix?: string;
      small?: boolean;
      icon?: boolean;
    }>(),
    { hasGroups: true, prefix: "If", small: false, icon: true },
  );

  const segments = computed(() => getConditionsSegments(props.conditions, props.hasGroups));
</script>

<template>
  <span
    v-if="segments.length"
    class="inline-flex items-baseline gap-1.5 text-muted-foreground"
    :class="props.small ? 'text-13' : 'text-sm'">
    <Funnel
      v-if="props.icon"
      class="size-3.5 shrink-0 translate-y-0.5" />
    <span>
      {{ props.prefix }}
      <span
        v-for="(segment, index) in segments"
        :key="index"
        >{{ segment.text }}</span
      >
    </span>
  </span>
</template>
